import {
	AWS,
	Adminjs,
	Auth0_Icon,
	Bootstrap,
	CSS,
	Expo_Icon,
	Express,
	Firebase,
	Git_Icon,
	GoogleCloud_Icon,
	HTML,
	JS,
	MongoDB_Icon,
	Mui,
	Mysql_icon,
	Nextjs_Logo,
	Nginx,
	Node,
	Postman,
	Psql,
	ReactImg,
	Redux,
	SocketIO_Icon,
	Swagger,
	Tailwind,
	TypeScript,
} from '../assets/assets';
import BipolarFactory from '../assets/experienceImg/bipolarFactory.svg';
import Brototype from '../assets/experienceImg/brototype.png';

let experience = [
	{
		img: BipolarFactory,
		title: 'Bipolar Factory',
		caption: 'The New Age Technology Studio',
		role: 'Back-end Developer',
		position: 'Full-Time (Remote)',
		duration: 'Nov 2022 to Jun 2023',
		status: 'Present',
		website: 'https://www.bipolarfactory.com/',
		linked_in: 'https://www.linkedin.com/company/bipolar-factory',
		techs_learned: [
			Nextjs_Logo,
			TypeScript,
			Mui,
			Git_Icon,
			GoogleCloud_Icon,
			ReactImg,
			Auth0_Icon,
			Postman,
			SocketIO_Icon,
			Adminjs,
			Mysql_icon,
			Swagger,
			Expo_Icon,
		],
		opinion:
			'Hashim has been a Back-end Developer at Bipolar Factory, and we are so proud of his work here. He has proved to be a diligent young guy with attention to detail.   During this period he has worked on multiple large scale projects for government and enterprise clients of Bipolar Factory. He is an honest, hardworking and ambitious individual.His ambitions and targets are always very high; touching the sky, and he has always enjoyed meeting new challenges in life and overcoming the obstacles with a calm attitude.I have worked closely with him as his mentor and friend on various projects, and I couldnt be more proud of him.He has always excelled at whatever he takes on.Hashim would be an asset to have on any team.',
		opinion_from: 'Udhaya Kumar (Head Of Engineering)',
		opinion_way: 'Words from LOR',
	},
	{
		img: Brototype,
		title: 'Brototype',
		caption: 'BROTHER  YOU NEVER HAD',
		role: 'Trainee Intern',
		position: 'Domain: MERN Stack',
		status: 'I became a MERN Stack Developer from here.',

		duration: 'March 2022 to Sep 2022',
		website: 'https://brototype.com',
		linked_in: 'https://www.linkedin.com/company/brototype/',
		youtube: 'https://www.youtube.com/@BrototypeMalayalam',
		instagram: 'https://www.instagram.com/brototype.malayalam/',
		techs_learned: [
			HTML,
			CSS,
			JS,
			Node,
			Express,
			MongoDB_Icon,
			ReactImg,
			Redux,
			Tailwind,
			Firebase,
			AWS,
			Nginx,
			Bootstrap,
			Psql,
		],
		opinion:
			'Brocamp helps the young Indian generation who had benefited nothing from our country’s poor education system by providing an intensive industry relevant training on the leading software technologies.Brocamp is not just another training institute where you go learn something and leave forever. Brocamp is a community of high performance people who support each other and to win together. Each Brocamp grad will always be in touch with our community and help the new buddies as a way of giving back.',
		opinion_from: 'Feel free to visit their website.',
		opinion_way: 'Words from website',
	},
];

export default experience;
